import {
  ANTD_TABLE_ENTITIES,
  entityDataMapper,
} from "../../components/AntdTable/AntdTable.constants";
import { IClauseForVerticalMapper } from "../../components/AntdTable/AntdTable.types";
import { getClauseCheckListForSelectedVertical } from "../../services/common.service";

export const ANTD_TABLE_TABLE_ACTIONS = {
  UPDATE_LOAD_OR_ERROR_STATE_OF_TABLE: "UPDATE_LOAD_OR_ERROR_STATE_OF_TABLE",
  SETTING_TABLE_DATA: "SETTING_TABLE_DATA",
  ANT_TABLE_UPDATE_SHOW_RECENT: "ANT_TABLE_UPDATE_SHOW_RECENT",
  RESET_ANTD_TABLE_STATE: "RESET_ANTD_TABLE_STATE",
  UPDATE_TABLE_ENTITY_DATA: "UPDATE_TABLE_ENTITY_DATA",
  REMOVE_TABLE_ENTITY_ROW: "REMOVE_TABLE_ENTITY_ROW",
};

const updateErrorThunk = (error: any, entity: string) => {
  return async (dispatch: any) => {
    console.error(error);
    dispatch({
      type: ANTD_TABLE_TABLE_ACTIONS.UPDATE_LOAD_OR_ERROR_STATE_OF_TABLE,
      payload: {
        data: {
          loading: false,
          error: error,
        },
        entity: entity,
      },
    });
  };
};

const updateLoadingOfTableDataThunk = (loading: boolean, entity: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: ANTD_TABLE_TABLE_ACTIONS.UPDATE_LOAD_OR_ERROR_STATE_OF_TABLE,
        payload: {
          data: {
            loading: loading,
          },
          entity: entity,
        },
      });
    } catch (error) {
      dispatch(updateErrorThunk(error, entity));
    }
  };
};

const setTableDataThunk = (data: any, entity: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: ANTD_TABLE_TABLE_ACTIONS.SETTING_TABLE_DATA,
        payload: {
          data: data,
          entity: entity,
        },
      });
    } catch (error) {
      dispatch(updateErrorThunk(error, entity));
    }
  };
};

export const updateTableEntityData = (
  data: { filters?: {}; filtersForRequestBody?: {}; selectedColumns?: any[] },
  entity: string
) => {
  return async (dispatch: any) => {
    try {
      dispatch(setTableDataThunk(data, entity));
    } catch (error) {
      dispatch(updateErrorThunk(error, entity));
    }
  };
};

export const fetchListData = ({
  entity,
  reqBody,
  extras = { loading: true },
}: any) => {
  return async (dispatch: any, getState: any) => {
    const requestId = `${Date.now()}-${Math.random()}`;
    try {
      dispatch({
        type: ANTD_TABLE_TABLE_ACTIONS.UPDATE_LOAD_OR_ERROR_STATE_OF_TABLE,
        payload: {
          data: {
            ...(extras?.loading ? { loading: true } : {}),
            requestId,
          },
          entity,
        },
      });
      const entityData = entityDataMapper?.[entity];
      const listApi = entityData?.listApi;
      const dataModel = entityData?.dataModel;

      const res = await listApi(reqBody);

      const { page, page_size } = reqBody?.queryParams;
      let data = {
        ...new dataModel(res),
        page: page,
        pageSize: page_size,
        selectedColumns: [],
        allClauseColumns: [],
      };

      // fetching the clauses for particular vertical
      if (
        entity === ANTD_TABLE_ENTITIES.KEY_CONTRACT_CLAUSES ||
        entity === ANTD_TABLE_ENTITIES.KEY_CONTRACT_CLAUSES_ADVANCED
      ) {
        let clauses = [];
        const res = await getClauseCheckListForSelectedVertical({
          verticalId: reqBody?.apiProps?.vertical_id,
        });

        clauses = res?.data?.map((clause: any) => {
          return {
            id: clause?.id,
            name: clause?.name,
            is_enabled: clause?.is_enabled,
          };
        });
        // .filter((clause: any) => clause?.is_enabled);

        const selectedColumns = clauses?.map(
          (clause: IClauseForVerticalMapper, idx: number) => {
            return {
              clause: clause,
              index: 3 + idx,
            };
          }
        );

        data = {
          ...data,
          clausesForVertical: clauses,
          selectedColumns: selectedColumns,
          allClauseColumns: selectedColumns,
        };
      }

      if (entity === ANTD_TABLE_ENTITIES.KEY_CONTRACT_CLAUSES_AGENTIC) {
        const clausesForVertical = (data as any)?.clausesForVertical || [];
        
        const selectedColumns = clausesForVertical?.map(
          (clause: IClauseForVerticalMapper, idx: number) => {
            return {
              clause: clause,
              index: 4 + idx,
            };
          }
        );

        data = {
          ...data,
          selectedColumns: selectedColumns,
          allClauseColumns: selectedColumns,
        };
      }

      const latestRequestId =
        getState?.()?.rootReducer?.antdTableReducer?.tableData?.[entity]?.requestId;

      if (latestRequestId && latestRequestId !== requestId) {
        return;
      }

      dispatch(setTableDataThunk(data, entity));
      dispatch(updateLoadingOfTableDataThunk(false, entity));
    } catch (error) {
      const latestRequestId =
        getState?.()?.rootReducer?.antdTableReducer?.tableData?.[entity]?.requestId;
      if (latestRequestId && latestRequestId !== requestId) {
        return;
      }
      dispatch(updateErrorThunk(error, entity));
    }
  };
};

export const resetAntdTableState = (entity: string) => {
  return async (dispatch: any) => {
    dispatch({
      type: ANTD_TABLE_TABLE_ACTIONS.RESET_ANTD_TABLE_STATE,
      payload: {
        entity: entity,
        entityData: {
          loading: true,
          tableData: {},
        },
      },
    });
  };
};

export const updateTableRowData = ({
  entity,
  data,
  rowId,
}: {
  entity: string;
  data: any;
  rowId: string;
}) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: ANTD_TABLE_TABLE_ACTIONS.UPDATE_TABLE_ENTITY_DATA,
        payload: {
          data: data,
          entity: entity,
          rowId: rowId,
        },
      });
    } catch (error) {
      dispatch(updateErrorThunk(error, entity));
    }
  };
};

export const removeTableRow = ({
  entity,
  rowId,
}: {
  entity: string;
  rowId: string;
}) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: ANTD_TABLE_TABLE_ACTIONS.REMOVE_TABLE_ENTITY_ROW,
        payload: {
          entity: entity,
          rowId: rowId,
        },
      });
    } catch (error) {
      dispatch(updateErrorThunk(error, entity));
    }
  };
};
